export const calendarDayViewConfig = {
  HOUR_STEP: 4,
  MIN_COLUMN_WIDTH: 200,
  ROW_HEIGHT: 120,
  HOURS_COLUMN_WIDTH: 80,
  MOBILE_HOURS_COLUMN_WIDTH: 50,
  CALENDAR_DAY_VIEW_HEIGHT: 500,
  HOUR_BORDER_COLOR: '#0E0E0F50',
  STEP_BORDER_COLOR: '#0E0E0F20',
  DISABLED_BACKGROUND_COLOR: '#EEEEEF80',
};
